import { createSlice } from '@reduxjs/toolkit';

const promptSlice = createSlice({
  name: 'prompt',
  initialState: {
    pendingPromptData: null,
  },
  reducers: {
    setPendingPromptData: (state, action) => {
      state.pendingPromptData = action.payload;
    },
    clearPendingPromptData: (state) => {
      state.pendingPromptData = null;
    },
  },
});

export const { setPendingPromptData, clearPendingPromptData } = promptSlice.actions;
export default promptSlice.reducer;